import { Route, Switch } from 'react-router-dom';
import ProtectedRoute from 'Helpers/ProtectedRoute';
import RedirectToHomepage from 'Helpers/RedirectToHomepage';
import MakePayment from 'Components/MakePayment';

const Routes = () => (
  <Switch>
    <ProtectedRoute path="/make-payment" component={MakePayment} />
    <Route path="/" component={RedirectToHomepage} />
  </Switch>
);

export default Routes;
